import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import Header from "./Header";
import RobotoLight from "../../assets/fonts/Roboto/Roboto-Light.ttf";
import RobotoBold from "../../assets/fonts/Roboto/Roboto-Bold.ttf";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  checkIncludeDateFairUsage,
  getDataFairUsagePackagesName,
  renderDiscountValidMonthsText,
} from "../../utils/helper";

// Register font
Font.register({ family: "RobotoLight", src: RobotoLight });
Font.register({ family: "RobotoBold", src: RobotoBold });

const styles = StyleSheet.create({
  body: {
    paddingTop: 13,
    paddingBottom: 20,
    paddingHorizontal: 10,
  },
  primaryText: {
    fontSize: 13,
    fontWeight: 600,
    fontFamily: "RobotoBold",
    margin: "10px 0px",
  },
  normalText: {
    fontSize: 11,
    fontWeight: 300,
    fontFamily: "RobotoLight",
    lineHeight: 1.5,
  },
  listItemText: {
    paddingLeft: 15,
    fontSize: 11,
    fontWeight: 300,
    fontFamily: "RobotoLight",
    lineHeight: 1.5,
  },
  signatureContainer: {
    margin: "15px 0px",
    flexDirection: "row",
    alignItems: "flex-end",
    gap: "20px",
  },
  signatureItem: {
    flexDirection: "row",
    alignItems: "flex-end",
    gap: "5px",
    marginTop: "15px",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  table: {
    margin: 10,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    // paddingVertical: 5,
  },
  cell: {
    flex: 1,
    textAlign: "center",
    paddingHorizontal: 5,
    borderWidth: 1,
    borderColor: "#ddd",
    backgroundColor: "#f9f9f9",
    fontSize: 11,
    padding: 4,
    fontFamily: "RobotoBold",
  },
  tdcell: {
    flex: 1,
    paddingHorizontal: 5,
    borderWidth: 1,
    borderColor: "#ddd",
    backgroundColor: "#ffffff",
    fontSize: 10,
    padding: 4,
    fontFamily: "RobotoLight",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  serviceBox: {
    marginBottom: 10,
    padding: 5,
    border: "1px solid #000",
    borderRadius: 4,
  },
});

const ContratcPdfV2 = ({
  generalInfo,
  platFormUpgradeCharge,
  routerValue,
  cordedPhone,
  cordedlessPhone,
  equipments,
  cliMobileNumber,
  totalTarrifCharges,
  totalAdditionalService,
  serviceTableData,
  isPlatformUpgradeChargeSeleted,
  selectedContractLength,
  debitDetail,
  cliData,
  discountDetails,
}) => {
  const isRouterOneOfCost = routerValue?.costType === "oneOfCost";
  const isCordedOneOfCost = cordedPhone?.costType === "oneOfCost";
  const isCordlessOneOfCost = cordedlessPhone?.costType === "oneOfCost";
  const isEuipmentsOneOfCost = equipments?.costType === "oneOfCost";
  const isFutureDate = serviceTableData?.some((x) => x.liveDate !== null);

  // Discount redux

  const renderConditionalTable = (datttaaa) => {
    return datttaaa.map((row, index) => {
      let legacyNamePrinted = false;
      let legacyAmountPrinted = false;

      return (
        <View style={styles.row} key={index}>
          <Text style={styles.tdcell}>{row.number}</Text>
          <Text style={styles.tdcell}>
            {row.package.map((innerItem, ind) => {
              let isIncludeDateFairUsage = innerItem?.includeDateFairUsage;
              if (innerItem.type === "legacy" && !legacyNamePrinted) {
                legacyNamePrinted = true;
                return (
                  <Text
                    key={ind}
                  >{`${innerItem.name}${innerItem?.includeDateFairUsage ? "*" : ""} x${row?.package?.length}\n`}</Text>
                );
              } else if (
                innerItem.type !== "legacy" &&
                innerItem.name !== "NA"
              ) {
                return (
                  <Text
                    key={ind}
                  >{`${innerItem.name} ${innerItem?.includeDateFairUsage ? "*" : ""}\n`}</Text>
                );
              }
              return null;
            })}
          </Text>
          <Text style={styles.tdcell}>
            {row.package.map((innerItem, ind) => {
              if (innerItem.type === "legacy" && !legacyAmountPrinted) {
                legacyAmountPrinted = true;
                const legacyAmount = innerItem.amount * row?.package?.length;
                return <Text key={ind}>{`£${legacyAmount.toFixed(2)}\n`}</Text>;
              } else if (
                innerItem.type !== "legacy" &&
                innerItem.name !== "NA"
              ) {
                return (
                  <Text key={ind}>{`£${innerItem.amount.toFixed(2)}\n`}</Text>
                );
              }
              return null; // Skip printing if legacy has already been printed
            })}
          </Text>
          <Text style={styles.tdcell}>{selectedContractLength?.title}</Text>
          {isFutureDate && (
            <Text style={styles.tdcell}>
              {row?.liveDate !== null
                ? moment(row?.liveDate).format("DD.MM.YY")
                : ""}
            </Text>
          )}
        </View>
      );
    });
  };

  const isIncludeDateFairUsageInLegacy = checkIncludeDateFairUsage(
    cliData,
    "legacyTariff",
    "legacy",
  );

  const isIncludeDateFairUsageInNgn = checkIncludeDateFairUsage(
    cliData,
    "digitalTariff",
    "ngnValue",
  );

  const dataFairUsagePackagesName = getDataFairUsagePackagesName(cliData);

  // PDF render tariff cost
  const renderTariffCost = (discountDetails) => {
    if (discountDetails) {
      return (
        <Text style={{ ...styles.listItemText }}>
          • Tariff total cost {renderDiscountValidMonthsText(discountDetails)} £
          {totalTarrifCharges.toFixed(2)} (+vat)
        </Text>
      );
    } else {
      return (
        <Text style={{ ...styles.listItemText }}>
          • Tariff total cost: £{totalTarrifCharges.toFixed(2)} (+vat)
        </Text>
      );
    }
  };

  return (
    <Document>
      <Page size="A4" wrap style={styles.body}>
        <Header>
          <Text style={styles.primaryText}>
            Trust Business Service Agreement
          </Text>
          <Text style={styles.normalText}>
            This Service Agreement ("Agreement") is made and entered into by and
            between Trust Business Limited ("Provider") and{" "}
            {generalInfo?.businessName} ("Customer"), in accordance with Ofcom
            regulations, on {moment(new Date()).format("DD.MM.YY [at] HH:MM")}.
          </Text>
          <Text style={styles.primaryText}>1. Definitions:</Text>
          {/* <View style={styles.list}> */}
          <Text style={styles.listItemText}>
            a. 'You', 'your' means the customer named in the application for the
            Services
          </Text>
          <Text style={styles.listItemText}>
            b. 'We', 'us', ‘provider’, means Trust Business Limited
          </Text>
          <Text style={styles.listItemText}>
            c. ‘Agreement’ means this Service Agreement inclusive of all
            addendums and attachments.
          </Text>
          <Text style={styles.listItemText}>
            d. 'Terms and Conditions' means the provisions set out in Terms and
            Conditions attached to Your pre-contract summary outlining the
            rights, responsibilities, and obligations of both the Provider and
            the Customer.
          </Text>
          <Text style={styles.listItemText}>
            e. 'Customer' means the individual or entity named in the
            application for the Services.
          </Text>
          <Text style={styles.listItemText}>
            f. 'Equipment' means any equipment provided by us to enable you to
            use the Services.
          </Text>
          <Text style={styles.listItemText}>
            g. 'Service(s)' means any service provided by Trust Business
            Limited.
          </Text>
          <Text style={styles.listItemText}>
            h. 'Live Date' means the date the Service is made available to you.
          </Text>
          <Text style={styles.listItemText}>
            i. 'Bill' means the monthly invoice you will receive for the
            Services supplied to you.
          </Text>
          <Text style={styles.listItemText}>
            j. 'Designated User' means any person(s) that you authorise as users
            of your digital telephone service.
          </Text>
          <Text style={styles.listItemText}>
            k. ‘PONR’ means point of no return. The point at which a Service
            cannot be cancelled.
          </Text>
          <Text style={styles.listItemText}>
            l. ‘Manual Payment’ is any payment not made by direct debit.
          </Text>
          <Text style={styles.listItemText}>
            m. 'Sign-up Date' means the date on which the Customer completes and
            electronically signs this Agreement via DocuSign.
          </Text>
          {/* </View> */}
          <Text style={styles.primaryText}>2. Services Provided </Text>
          <Text style={styles.normalText}>
            Provider agrees to provide the following service to You, the
            Customer:
          </Text>
          {/* <View
            style={{
              ...styles.list,
              margin: "10px 0px",
            }}
          > */}
          {/* cliData mapping */}
          <View style={styles.table}>
            <View style={styles.row}>
              <Text style={styles.cell}>Connection</Text>
              <Text style={styles.cell}>Tariff</Text>
              <Text style={styles.cell}>Monthly Total</Text>
              <Text style={styles.cell}>Contract Term</Text>
              {isFutureDate && <Text style={styles.cell}>Live Date</Text>}
            </View>

            {renderConditionalTable(serviceTableData)}
          </View>
          {/* <Text style={{ ...styles.listItemText, marginTop: "10px" }}>
            • [15] [21] [Cost] [20]
          </Text>
          <Text style={styles.listItemText}>• [17] [23] [Cost] [20]</Text>
          <Text style={styles.listItemText}>• [17] [23] [Cost] [20]</Text>
          <Text style={styles.listItemText}>• [16] [22] [Cost] [20] </Text>
          <Text style={{ ...styles.listItemText, marginBottom: "10px" }}>
            • [16] [22] [Cost] [20]{" "}
          </Text> */}
          {/* </View> */}
          <Text style={styles.primaryText}>3. Terms of Agreement </Text>
          <Text style={styles.normalText}>
            {/* This Agreement shall commence on the sign up date for a period of{" "}
            {selectedContractLength?.title}, unless terminated or extended in
            accordance with this Agreement.
           
            This Agreement shall be legally binding upon execution via DocuSign
            and shall commence on the sign-up date for a fixed period of
            eighteen (18) months. */}
            {/* 2nd */}
            {/* use this */}
            This Agreement becomes legally binding once signed via DocuSign and
            will begin on the Sign-up Date, continuing for a fixed term of{" "}
            {selectedContractLength?.title}.
          </Text>
          <Text style={styles.primaryText}>4. Fees and Payment </Text>
          <Text style={{ ...styles.normalText, marginBottom: "10px" }}>
            Customer agrees to pay Provider for the Services as follows:
          </Text>
          {(isPlatformUpgradeChargeSeleted ||
            (isRouterOneOfCost && routerValue.value > 0) ||
            (isCordedOneOfCost && cordedPhone.value > 0) ||
            (isCordlessOneOfCost && cordedlessPhone.value > 0) ||
            (isEuipmentsOneOfCost && equipments.value !== "")) && (
            <Text style={styles.normalText}>One-off costs:</Text>
          )}

          <View>
            {/* show when any of connection box selected platform upgrade charge */}
            {isPlatformUpgradeChargeSeleted && (
              <Text style={styles.listItemText}>
                • Platform Upgrade Fee:{" "}
                {`£${platFormUpgradeCharge?.salePrice.toFixed(2)}`} (+vat)
              </Text>
            )}
            {/* show when router has some value */}
            {isRouterOneOfCost && routerValue.value > 0 && (
              <Text style={styles.listItemText}>
                •{" "}
                {`${
                  routerValue?.isUpgrade ? "Advanced" : ""
                } Router configuration and delivery:`}{" "}
                {`£${routerValue?.price.toFixed(2)}`} (+vat)
              </Text>
            )}

            {isCordedOneOfCost && cordedPhone.value > 0 && (
              <Text style={styles.listItemText}>
                • Corded phone configuration and delivery:{" "}
                {`£${cordedPhone?.price.toFixed(2)}`} (+vat)
              </Text>
            )}

            {isCordlessOneOfCost && cordedlessPhone.value > 0 && (
              <Text style={styles.listItemText}>
                • Cordless phone configuration and delivery:{" "}
                {`£${cordedlessPhone?.price.toFixed(2)}`} (+vat)
              </Text>
            )}

            {isEuipmentsOneOfCost && equipments?.value.trim() !== "" && (
              <Text style={styles.listItemText}>
                • {equipments?.name || equipments?.value}:{" "}
                {`£${equipments?.price.toFixed(2)}`} (+vat)
              </Text>
            )}
          </View>

          <Text style={{ ...styles.normalText, marginTop: "10px" }}>
            Monthly Service Cost:
          </Text>

          {/* <Text style={{ ...styles.listItemText }}>
            • Tariff total cost{" "}
            {discountDetails
              ? renderDiscountValidMonthsText(discountDetails)
              : ""}
            : £{totalTarrifCharges.toFixed(2)} (+vat)
          </Text> */}

          {renderTariffCost(discountDetails)}

          {totalAdditionalService && (
            <View>
              <Text style={{ ...styles.normalText, margin: "5px 0px" }}>
                Additional services
              </Text>

              {(() => {
                const showOnce = [
                  "Care Level 2",
                  "Care Level 3",
                  "Care Level 4",
                  "Static IP",
                  "Business Assurance",
                ];

                const allServices = [];

                cliData?.forEach((x, index) => {
                  if (!x.additionalService.isSelected) return;

                  // Process all line values, not just [0]
                  x.lineValues?.forEach((services, lineIndex) => {
                    let selectedServices = [];

                    if (x.digitalTariff.isSelected) {
                      selectedServices = [
                        services?.ngnService1,
                        services?.ngnService2,
                        services?.ngnService3,
                        services?.ngnService4,
                      ].filter(Boolean);
                    } else if (x.legacyTariff.isSelected) {
                      selectedServices = [
                        services?.legacyService1,
                        services?.legacyService2,
                        services?.legacyService3,
                        services?.legacyService4,
                      ].filter(Boolean);
                    }

                    // Filter duplicates for showOnce services
                    const uniqueServices = selectedServices.filter(
                      (service, idx, self) => {
                        if (!showOnce.includes(service.value)) return true;
                        return (
                          idx ===
                          self.findIndex((s) => s.value === service.value)
                        );
                      },
                    );

                    allServices.push(...selectedServices);
                  });
                });

                return allServices.map((service, i) => (
                  <View key={`service-${i}`}>
                    <Text style={styles.listItemText}>
                      • {service.value}: £{service.salePrice.toFixed(2)} (+vat)
                    </Text>
                  </View>
                ));
              })()}

              {/* <Text style={styles.listItemText}>
                • Additional service total cost: £
                {totalAdditionalService.toFixed(2)} (+vat)
              </Text> */}
            </View>
          )}
          {/* show when router has some value */}
          {!isRouterOneOfCost && routerValue.value > 0 && (
            <Text style={styles.listItemText}>
              •{" "}
              {`${
                routerValue?.isUpgrade ? "Advanced" : ""
              } Router configuration and delivery:`}{" "}
              {`£${routerValue?.price.toFixed(2)} (+vat)`}
            </Text>
          )}

          {!isCordedOneOfCost && cordedPhone.value > 0 && (
            <Text style={styles.listItemText}>
              • Corded phone configuration and delivery:{" "}
              {`£${cordedPhone?.price.toFixed(2)}`} (+vat)
            </Text>
          )}

          {!isCordlessOneOfCost && cordedlessPhone.value > 0 && (
            <Text style={styles.listItemText}>
              • Cordless phone configuration and delivery:{" "}
              {`£${cordedlessPhone?.price.toFixed(2)}`} (+vat)
            </Text>
          )}

          {!isEuipmentsOneOfCost && equipments?.value.trim() !== "" && (
            <Text style={{ ...styles.listItemText }}>
              • {equipments?.name || equipments?.value}:{" "}
              {`£${equipments?.price.toFixed(2)}`} (+vat)
            </Text>
          )}

          {generalInfo.eBilling === "No" && (
            <Text style={{ ...styles.listItemText }}>
              • Paper Billing Charges: £5 (+vat)
            </Text>
          )}

          {debitDetail?.no === true && (
            <Text style={{ ...styles.listItemText }}>
              • Payment Processing Fee: £7 (+vat)
            </Text>
          )}

          {/* </View> */}
          <Text style={{ ...styles.normalText, marginTop: "10px" }}>
            Payments are due on or around the 16th of each month.
          </Text>
          {(isIncludeDateFairUsageInLegacy || isIncludeDateFairUsageInNgn) && (
            <Text style={{ ...styles.normalText, marginTop: "10px" }}>
              {dataFairUsagePackagesName.join(", ")} is subject to a *fair usage
              policy of 400 GB per month. Data used outside of this allowance is
              charged at 3p per MB.
            </Text>
          )}
          <Text style={{ ...styles.normalText, margin: "10px 0px" }}>
            Out of bundle Local and National Calls will be charged at 4p per
            minute and calls to major mobile network (T mobile, Orange, O2,
            Vodafone, EE & network 3), will be charged at 16p per minute. Out of
            bundle calls are billed per minute; a connection charge of 20p
            applies to mobile call and 18p to all other calls. A £3 broadband
            surcharge may apply if you are in a secluded rural area, depending
            on your exchange. If this is applicable it will be communicated to
            you prior to Your Live Date.
          </Text>

          {discountDetails?.cpsTerms && (
            <>
              <Text style={{ ...styles.normalText, marginBottom: "10px" }}>
                Any promotional pricing (including free broadband or line
                rental) is strictly conditional upon the Customer transferring
                its merchant services to Trust Business and maintaining active
                card processing broadly consistent with the average monthly
                turnover evidenced at point of sale, and as per the Cashflows
                Docusign agreement.
              </Text>
              <Text style={{ ...styles.normalText, marginBottom: "10px" }}>
                If the Customer fails to transfer the merchant facility, cancels
                it, or processes materially lower turnover than disclosed, the
                promotional pricing shall automatically cease. Standard service
                charges shall apply from the Service Live Date, and any
                promotional discount already applied shall become immediately
                due and payable.
              </Text>
            </>
          )}

          <Text style={{ ...styles.normalText, marginBottom: "10px" }}>
            We will process Your monthly payment by direct debit within 10 days
            of the invoice date. A direct debit must be set up prior to the
            first invoice being received to avoid an additional £7 payment
            processing fee. Invoices will be sent via e-billing to avoid a £5
            paper billing charge.
          </Text>
          {/* <Text style={{ ...styles.normalText, marginBottom: "10px" }}>
            The first payment is usually processed 14 days after your line is
            live with us. Do you understand? [Yes/No]
          </Text> */}
          <Text style={styles.primaryText}>5. Customer Responsibilities </Text>
          <Text style={styles.normalText}>Customer agrees to:</Text>
          {/* <View style={styles.list}> */}
          <Text style={{ ...styles.listItemText, marginTop: "10px" }}>
            a. Provide accurate information to Provider.
          </Text>
          <Text style={styles.listItemText}>
            b. Ensure that equipment is properly used and maintained.
          </Text>
          <Text style={styles.listItemText}>
            c. Allow Provider reasonable access to the premises for
            installation, maintenance, and repair of equipment.
          </Text>
          <Text style={styles.listItemText}>
            d. Allow external access via remote control software and other
            applications, as required.
          </Text>
          <Text style={styles.listItemText}>
            e. Comply with Terms and Conditions attached to Your precontract
            summary.
          </Text>
          <Text style={styles.listItemText}>
            f. Not use the services for any unlawful purposes or allow others to
            do so.
          </Text>
          <Text style={styles.listItemText}>
            g. Comply with all reasonable instructions provided by us in
            relation to the services.
          </Text>
          <Text style={styles.listItemText}>
            h. Notify us immediately if the equipment is stolen or if you become
            aware of any unauthorised use of the Service.
          </Text>
          <Text style={styles.listItemText}>
            i. Pay for services provided to the Provider, by direct debit, no
            later than the invoice due date.
          </Text>
          {/* <Text style={{ ...styles.listItemText, marginBottom: "10px" }}>
            j. ‘Local and National Calls’ are all UK national landline calls
            starting with 01, 02, 03.
          </Text> */}
          {/* </View> */}
          <Text style={styles.primaryText}>6. Provider Responsibilities </Text>
          <Text style={styles.normalText}>Provider agrees to:</Text>
          <Text style={{ ...styles.listItemText, marginTop: "10px" }}>
            a. Provide the Services in a professional manner.
          </Text>
          <Text style={styles.listItemText}>
            b. Respond to customer service requests in a timely manner.
          </Text>
          <Text style={styles.listItemText}>
            c. Maintain and repair equipment as necessary.
          </Text>
          <Text style={{ ...styles.listItemText, marginBottom: "10px" }}>
            d. No mid-contract price increases.
          </Text>
          <Text style={styles.primaryText}>7. Equipment </Text>
          <Text style={styles.listItemText}>
            Provider may lease equipment to Customer for the duration of the
            Terms of Agreement. Customer agrees to return the equipment in good
            condition upon termination of the Agreement. Damaged or unreturned
            equipment may result in additional charges.
          </Text>
          <Text style={styles.primaryText}>8. Termination </Text>
          <Text style={styles.listItemText}>
            You may cancel after the Live Date upon 14 days' written notice.
            Early termination and/or breach of contract by Customer may result
            in a fee as set out in the early termination schedule section of the
            contract summary. Equipment provided by Trust Business Limited to
            the Customer must be returned at the expense of the Customer upon
            termination of this agreement or as required.
          </Text>
          <Text style={styles.primaryText}>9. Limitation of Liability </Text>
          <Text style={styles.listItemText}>
            Provider's liability for any claims arising from this Agreement is
            limited to the amount paid by Customer for the Services during the
            total active months preceding the claim. We exclude all liability
            for the accuracy of any material or information provided by us or
            made available by any third party.
          </Text>
          <Text style={styles.primaryText}>10. Governing Law</Text>
          <Text style={styles.listItemText}>
            This Agreement shall be governed by and construed in accordance with
            the laws of the United Kingdom.
          </Text>
          <Text style={styles.primaryText}>11. Entire Agreement </Text>
          <Text style={styles.listItemText}>
            This Agreement constitutes the entire agreement between the parties
            and supersedes all prior agreements or understandings, whether
            written or oral.
          </Text>
          <Text style={styles.primaryText}>12. Amendments </Text>
          <Text style={styles.listItemText}>
            This Agreement may be amended only in writing and signed by both
            parties.
          </Text>
          <Text style={styles.primaryText}>Customer Acknowledgment </Text>
          <Text style={styles.listItemText}>
            By signing below, Customer acknowledges that they have read,
            understood, and agree to the terms and conditions of this Agreement.
          </Text>
          <Text style={styles.primaryText}>Customer Information:</Text>
          <Text style={{ ...styles.listItemText, marginTop: "10px" }}>
            • {generalInfo?.businessName || "NA"}
          </Text>
          <Text style={styles.listItemText}>
            • {`${generalInfo?.title} ${generalInfo?.name || "NA"}`}
          </Text>
          <Text style={styles.listItemText}>
            •{" "}
            {`${generalInfo?.address1}, ${generalInfo?.city || "NA"}  ${
              generalInfo?.postCode || "NA"
            }`}
          </Text>
          {cliMobileNumber && (
            <Text style={styles.listItemText}>• {cliMobileNumber}</Text>
          )}
          <Text style={styles.listItemText}>
            • {generalInfo?.email || "NA"}
          </Text>
          <Text style={{ ...styles.listItemText, marginBottom: "10px" }}>
            • {generalInfo?.mobileNo || "NA"}
          </Text>
          <Text style={styles.primaryText}>Provider Information:</Text>
          {/* <Text style={{ ...styles.listItemText, marginTop: "10px" }}>
            • {generalInfo?.businessName || "NA"}
          </Text> */}
          <Text style={styles.listItemText}>• Trust Business Limited</Text>
          <Text style={styles.listItemText}>
            • 167-169 Great Portland Street, 5th Floor, London, England, W1W 5PF
          </Text>
          <Text style={styles.listItemText}>• 0207 629 9888</Text>
          <Text style={{ ...styles.listItemText, marginBottom: "10px" }}>
            • support@trust-business.co.uk
          </Text>
          {/* <Text style={{ ...styles.listItemText, marginTop: "10px" }}>
            I. You are the {generalInfo?.owner} of{" "}
            {generalInfo?.businessName || "NA"}, and you are authorised to make
            decisions on behalf of the business: [Yes / No]
          </Text>

          <Text style={styles.listItemText}>
            II. Do You agree to the terms set out in this Agreement? [Yes / No]
          </Text>
          <Text style={styles.listItemText}>
            III. Do you confirm that you have received a pre-contract summary
            along with the Terms and Conditions for this Service Agreement? [Yes
            / No]
          </Text>
          <Text style={styles.listItemText}>
            IV. Do You agree to and understand Section 4. Fees and Payment? [Yes
            / No]
          </Text>
          <Text style={styles.listItemText}>
            V. Do you understand that Your first month’s invoice will include
            the current month plus one month in advance. [Yes / No]
          </Text>
          <Text style={styles.listItemText}>
            VI. Do you opt in to receive communications via email, text,
            WhatsApp, post? [Yes / No]
          </Text>
          <Text style={{ ...styles.listItemText, marginBottom: "10px" }}>
            VII. Do you opt in to the Trust Business directory? [Yes / No]
          </Text>
          <Text style={{ ...styles.listItemText, marginTop: "10px" }}>
            We will now begin to process your Agreement and provision Your
            service. We will send a welcome pack via email within 3 to 5 working
            days. Should you not receive the paperwork, please call our customer
            service team on our local rate non-geographic number 08455610077.
          </Text>
          <Text style={styles.primaryText}>Signatures:</Text>
          <Text style={{ ...styles.normalText, marginTop: "5px" }}>
            Customer Name: {`${generalInfo?.title} ${generalInfo?.name}`}
          </Text>
          <View style={styles.signatureContainer}>
            <View style={styles.signatureItem}>
              <Text style={styles.normalText}>Signature:</Text>
              <Text style={styles.normalText}>_____________________</Text>
            </View>
            <View style={styles.signatureItem}>
              <Text style={styles.normalText}>Date:</Text>
              <Text style={styles.normalText}>_____________________</Text>
            </View>
          </View> */}
          {/* <Text style={{ ...styles.normalText, marginTop: "5px" }}>
            CEO: Nicholas Lightstone
          </Text> */}
          {/* <View style={styles.signatureContainer}>
            <View style={styles.signatureItem}>
              <Text style={styles.normalText}>Signature:</Text>
              <Text style={styles.normalText}>_____________________</Text>
            </View>
            <View style={styles.signatureItem}>
              <Text style={styles.normalText}>Date:</Text>
              <Text style={styles.normalText}>_____________________</Text>
            </View>
          </View> */}
          {/* <Text style={{ ...styles.normalText, marginTop: "5px" }}>
            Sales Director: [2]{" "}
          </Text> */}
          {/* <View style={styles.signatureContainer}>
            <View style={styles.signatureItem}>
              <Text style={styles.normalText}>Signature:</Text>
              <Text style={styles.normalText}>_____________________</Text>
            </View>
            <View style={styles.signatureItem}>
              <Text style={styles.normalText}>Date:</Text>
              <Text style={styles.normalText}>_____________________</Text>
            </View>
          </View> */}
        </Header>

        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
      <Page size="A4" wrap style={styles.body}>
        <Header>
          <Text style={{ ...styles.listItemText, marginTop: "12px" }}>
            I. You are the confirmed {generalInfo?.designation} of{" "}
            {generalInfo?.businessName || "NA"}, and you are fully authorised to
            make decisions on behalf of the business?
          </Text>
          <View style={{ height: 15 }}></View>

          <Text style={styles.listItemText}>
            II. Do You agree to the terms set out in this Agreement?
          </Text>
          <View style={{ height: 15 }}></View>
          <Text style={styles.listItemText}>
            III. Do you confirm that you have received a pre-contract summary
            along with the Terms and Conditions for this Service Agreement?
          </Text>
          <View style={{ height: 15 }}></View>

          <Text style={styles.listItemText}>
            IV. Do You agree to and understand Section 4. Fees and Payment?
          </Text>
          <View style={{ height: 15 }}></View>

          <Text style={styles.listItemText}>
            V. Do you understand that Your first month’s invoice will include
            the current month plus one month in advance.
          </Text>
          <View style={{ height: 15 }}></View>

          <Text style={styles.listItemText}>
            VI. Do you opt in to receive communications via email, text,
            WhatsApp, post?
          </Text>
          <View style={{ height: 15 }}></View>

          <Text style={styles.listItemText}>
            VII. Do you opt in to the Trust Business directory?
          </Text>
          <View style={{ height: 15 }}></View>

          <Text style={{ ...styles.listItemText, marginBottom: "10px" }}>
            VIII. The first payment is usually processed 14 days after your line
            is live with us. Do you understand?
          </Text>
          {discountDetails?.cpsTerms && (
            <Text style={{ ...styles.listItemText, marginBottom: "10px" }}>
              IX. I confirm I have read Section 4 and understand promotional
              pricing requires merchant turnover within 20% of the Cashflows
              agreement.
            </Text>
          )}

          <View style={{ height: 15 }}></View>

          <Text style={{ ...styles.listItemText, marginTop: "10px" }}>
            We will now begin to process your agreement and provision your
            service. Should you require any help or assistance, please call our
            customer service team on our local rate non-geographic number 0207
            629 9888 or email us at support@trust-business.co.uk.
          </Text>
          <Text style={styles.primaryText}>Signatures:</Text>
          <Text style={{ ...styles.normalText, marginTop: "5px" }}>
            Customer Name: {`${generalInfo?.title} ${generalInfo?.name}`}
          </Text>
          {/* <View style={styles.signatureContainer}> */}
          <View style={styles.signatureItem}>
            <Text style={styles.normalText}>Signature:</Text>
            <Text style={styles.normalText}>_____________________</Text>
          </View>
          <View style={styles.signatureItem}>
            <Text style={styles.normalText}>Date:</Text>
            <Text style={styles.normalText}>_____________________</Text>
          </View>
          {/* </View> */}
        </Header>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `${pageNumber} / ${totalPages}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default ContratcPdfV2;
